export enum VasImages {
  VasBump = 'vas-bump',
  VasClosetPromo = 'vas-closet-promo',
  VasClosetPromoStats = 'vas-closet-promo-stats',
}
